import React from 'react';
import { css } from '../../../customEmotion';

import { useMUITheme } from '../../styles/theme';
import Typography from '../../Typography';

interface PlaceholderProps {
  text: string;
  disabled: boolean;
}

const Placeholder: React.FC<PlaceholderProps> = ({
  text,
  disabled = false,
}) => {
  const theme = useMUITheme();

  if (!text) {
    return null;
  }

  return (
    <Typography
      component="p"
      variant="body2"
      className={css`
        display: flex;
        align-items: center;
        color: ${disabled
          ? theme.palette.grey['300']
          : theme.palette.grey['500']};
      `}
    >
      {text}
    </Typography>
  );
};

export default Placeholder;
